import { Navigate } from 'react-router-dom';

import { type FCC } from '@eluve/components';
import {
  useArePostHogFlagsLoaded,
  useIsPostHogFeatureFlagEnabled,
} from '@eluve/posthog-react';
import { useIsFeatureFlagEnabled } from '@eluve/smart-blocks';

export const useIsCarePlanFeatureEnabled = (): boolean => {
  const isMedplumEnabled = useIsFeatureFlagEnabled('MEDPLUM');
  const isCarePlansEnabled = useIsPostHogFeatureFlagEnabled('CARE_PLANS');

  return isMedplumEnabled && isCarePlansEnabled;
};

export const CarePlanFeatureFlaggedPage: FCC<{
  redirectTo?: string;
}> = ({ children, redirectTo = '/' }) => {
  const arePostHogFlagsLoaded = useArePostHogFlagsLoaded();
  const isEnabled = useIsCarePlanFeatureEnabled();

  if (!arePostHogFlagsLoaded) {
    return null;
  }

  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};
